import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

import { IHookCallbacks } from 'src/hooks/common.hooks.interfaces';

import { GET_PERMISSIONS_GROUPS } from './get-permissions-groups.hook';

export const DELETE_PERMISSION_GROUP = gql`
  mutation($permissionGroupId: String!) {
    deletePermissionGroup(permissionGroupId: $permissionGroupId) {
      _id
    }
  }
`;

export const useDeletePermissionGroup = ({ onSuccess, onAccountError }: IHookCallbacks) => {
  const { t } = useTranslation('settings');

  const [deletePermissionGroup] = useMutation(DELETE_PERMISSION_GROUP, {
    onCompleted: data => {
      onSuccess();
      if (data?.deletePermissionGroup?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('permissionGroupSettings.notifications.permissionGroupRemoved'),
        });
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      if (error?.extensions?.exception?.status === 302) {
        return onAccountError && onAccountError();
      }

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: t('userProfileSettings.error.title'),
        description: t('userProfileSettings.error.subTitle'),
      });
    },
    refetchQueries: [GET_PERMISSIONS_GROUPS],
  });

  return (permissionGroupId: String) =>
    deletePermissionGroup({
      variables: { permissionGroupId },
    });
};
